<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Criar Token Desktop <i class="fa fa-desktop"></i></h4>
          </div>
        <div class="col-md-12">
          <a class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" href="https://yooga-update.s3-sa-east-1.amazonaws.com/Criar_Token.rar">Download do Conversor de xlsx para JSON</a>
        </div>
        <input type="file" @change="processFile($event)" class="form-control">
        <div class="col-md-12" style="padding-bottom:20px">
          <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" @click="criaToken">Gerar Token</button>
        </div>

        <div class="col-md-12 alert alert-success" v-if="success">Token Criado com Sucesso, Token: {{idi.data.chave_ativacao}}</div>
        <div class="col-md-12 alert alert-danger" v-if="fail">{{mensagem_erro}}</div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {
  Card,
} from 'src/components'
import moment from 'moment'
import InstalacaoService from '@/services/InstalacaoService.js'

export default {  
    components: {
      Card,
      moment
    },
    data() {
      return {
        token: null,
        success:false,
        fail:false,
        idi:null,
        mensagem_erro:null,
      }
    },
    methods:{
      processFile(event) {        
        var reader = new FileReader();
        reader.onload = this.onReaderLoad;
        reader.readAsText(event.target.files[0],'windows-1252');
      },
      onReaderLoad(event){
        var obj = JSON.parse(event.target.result);
        this.token = obj; 
      },
      criaToken(){
        this.token.ambiente = "P";
        axios.post('https://tomcat.yooga.com.br/YoogaServlet/Token', JSON.stringify(this.token)).then(res => {
          this.success = true;
          this.fail=false;
          this.idi = res;
          this.mensagem_erro = null;
        }).catch(err=>{
          this.success = false;
          this.fail=true;
          this.mensagem_erro = err.response.data;
          this.idi = null;
        });
      }
    },
    mounted() {
      this.loadInstalacoes()
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
</style>